import React from 'react';

import ElementConstants from '../../../../shared/constants/elements';

import FormActions from '../../../../shared/actions/form';

import RadioButton from '../../form-elements/inputs/radio-button';
import Checkbox from '../../form-elements/inputs/checkbox';
import MultiChoicePayOption from '../../form-elements/inputs/multi-choice-pay-option';

import SVGIcon from '../../../../../../../common/react/components/svg-icon';
import DraggableItems from "../../../constants/dnd";
import { DragSource, DropTarget } from '../../../../../../../common/react-dnd-2.6.0/dist/ReactDnD.min';
import ReactDOM from "react-dom";

const inputSource = {
    // React-DnD method returns dragged item props upon initiating drag operation
    beginDrag(props) {
        return props;
    }
}

const dropTarget = {

    /**
     * React-DnD @method drop
     * dispatches input move event when user drops an input in an input group target.
     * The order is determined by the position of the dragged element relative to
     * the existing elements.
     * @params are all from React-DnD
     */
    drop(props, monitor, component) {
        const draggedItem = monitor.getItem();
        const targetItem = props;

        // Determine rectangle on screen
        const targetBoundingRect = ReactDOM.findDOMNode(component).getBoundingClientRect();
        // Get vertical middle of target
        const targetMiddleY = ( targetBoundingRect.bottom - targetBoundingRect.top ) / 2;
        // Determine mouse position
        const clientOffset = monitor.getClientOffset();
        // Get number of pixels to the top of target
        const targetClientY = clientOffset.y - targetBoundingRect.top;

        if (
            ( draggedItem.rowIndex !== targetItem.rowIndex )
        ) {
            return;
        }

        if ( monitor.canDrop() ) {
            FormActions.moveInputFromGroup(draggedItem.fieldsetIndex, draggedItem.rowIndex, draggedItem.index, draggedItem.choiceNumber, targetItem.choiceNumber, 'choices');
            // Reset drop-zone state after drop operation
            component.setState({
                sameRow: draggedItem.rowIndex === targetItem.rowIndex,
                topQuadrantHovered: false,
                bottomQuadrantHovered: false
            });
            return;
        }
    },

    /**
     * React-DnD @method hover
     * display an active drop-zone upon hovering an input in a group.
     * The order is determined by the position of the dragged element relative to
     * the existing elements.
     * @params are all from React-DnD
     */
    hover(props, monitor, component) {
        const draggedItem = monitor.getItem();
        const targetItem = props;

        // Determine rectangle on screen
        const targetBoundingRect = ReactDOM.findDOMNode(component).getBoundingClientRect();
        // Get vertical middle of target
        const targetMiddleY = ( targetBoundingRect.bottom - targetBoundingRect.top ) / 2;
        // Determine mouse position
        const clientOffset = monitor.getClientOffset();
        // Get number of pixels to the top of target
        const targetClientY = clientOffset.y - targetBoundingRect.top;

        // Mouse is positioned in top quadrant of drop target moving down
        if ( targetClientY < targetMiddleY ) {
            component.setState({
                sameRow: draggedItem.rowIndex === targetItem.rowIndex,
                topQuadrantHovered: true,
                bottomQuadrantHovered: false
            });
        }

        // Mouse is positioned in bottom quadrant of drop target moving up
        if ( targetClientY > targetMiddleY ) {
            component.setState({
                sameRow: draggedItem.rowIndex === targetItem.rowIndex,
                topQuadrantHovered: false,
                bottomQuadrantHovered: true
            });
        }
    }

}

@DragSource(DraggableItems.INPUT_FROM_GROUP, inputSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
}))
@DropTarget([DraggableItems.INPUT_FROM_GROUP, DraggableItems.INPUT_FROM_GROUP], dropTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
}))
export default class GroupedInput extends React.Component {
	constructor(props) {
		super(props);
	}

	handleBlur = () => {
	    setTimeout(() => {
            const {
                fieldsetIndex,
                rowIndex,
                index,
                choiceNumber
            } = this.props;

            const oldValue = this.props.data.label;
            const inputValues = this.refs.groupedInput.refs;
            let newValue = [];

            for (let key in inputValues) {
                newValue.push(inputValues[key].refs.input.value);
            }

            if ( newValue !== oldValue ) {
                FormActions.updateGroupedElementLabel(fieldsetIndex, rowIndex, index, choiceNumber, newValue);
            }
        }, 0)
	}

	remove = () => {
		this.props.removeCallback(this.props.choiceNumber);
	}

	render() {
		const {
            type,
            data,
            parentId,
            showRemoveOption,
            isOver,
            connectDropTarget,
            connectDragSource,
            connectDragPreview,
            isDragging
        } = this.props;

        const groupedInputClasses = ( isDragging ) ? 'dragging grouped-input' : 'grouped-input';
        const topDropZoneClasses = ( isOver && this.state.sameRow && this.state.topQuadrantHovered ) ? 'drop-zone-indicator' : 'hidden drop-zone-indicator';
        const bottomDropZoneClasses = ( isOver && this.state.sameRow && this.state.bottomQuadrantHovered ) ? 'drop-zone-indicator' : 'hidden drop-zone-indicator';

		return connectDropTarget(
            connectDragPreview(
                <div>
                    <div className={topDropZoneClasses}></div>
                        <div className={groupedInputClasses} onBlur={this.handleBlur}>
                            <div style={{ padding: 0, margin: '0 5px 2px 0' }} className='left tools'>
                                {connectDragSource(
                                    <a className='move' href='javascript:;'>
                                        <SVGIcon name='drag-handle' />
                                    </a>
                                )}
                            </div>
                            { type === ElementConstants.INPUT_GROUPS.RADIO_BUTTONS &&
                                <RadioButton ref='groupedInput' data={data} />
                            }
                            { type === ElementConstants.INPUT_GROUPS.CHECKBOXES &&
                                <Checkbox ref='groupedInput' data={data} />
                            }
                            { type === ElementConstants.PAYMENTS.MULTI_CHOICE &&
                                <MultiChoicePayOption ref='groupedInput' data={data} parentId={parentId} />
                            }
                            { showRemoveOption &&
                                <div className='tools'>
                                    <a className='delete' href='javascript:;' onClick={this.remove}>
                                        <SVGIcon name='trash-o' />
                                    </a>
                                </div>
                            }
                        </div>
                    <div className={bottomDropZoneClasses}></div>
                </div>
		));
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/input-groups/grouped-input.js